module.exports = __webpack_public_path__ + "fonts/c4aef0d4-bfcf-4790-acf5-909881f411e8.d3e3d90b.woff";